import React from 'react'
import { Button, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';

function ReuseModal({ data, change }) {
  const navigate = useNavigate();
  return (
    <Modal
      title=""
      open={data}
      onOk={() => { navigate('/createApp') }}
      onCancel={change}
      width={800}
      cancelText='Cancel'
      maskClosable={false}
      closeIcon={false}
      okText='Confirm'     >
      <p className='modal_style'>By disagreeing with the Terms and Conditions, the application will be discontinued. Please confirm you wish to close and discontinue this application.</p>
    </Modal>
  )
}

export default ReuseModal